import { useState } from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaWhatsapp } from "react-icons/fa";

import "./Navbar.css";

function Navbar() {

  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      {/* Top Bar */}
      <div className="topbar">
        <div className="top-left">
          <span>✉ info@urbanbrick.in.net</span>
          
        </div>

        <div className="top-right">
          <FaFacebookF />
          <FaTwitter />
          <FaLinkedinIn />
          <FaWhatsapp />
          <span className="lang">English ▼</span>
        </div>
      </div>

      {/* Main Navbar */}
      <nav className="navbar">

        {/* LOGO */}
        <div className="logo-text">
          <img src="/logo.png" alt="logo" className="logo-img" />
        </div>

        {/* NAV LINKS */}
        <ul className={`nav-links ${menuOpen ? "active" : ""}`}>
            <li><Link to="/" onClick={() => setMenuOpen(false)}>Home</Link></li>

           <li><Link to="/sell" onClick={() => setMenuOpen(false)}>
                  Properties for Sale
           </Link></li>

          <li><Link to="/buy" onClick={() => setMenuOpen(false)}>
                Buyer Requirements
          </Link></li>

          <li><Link to="/rent" onClick={() => setMenuOpen(false)}>
                 Properties for Rent
          </Link></li>

          <li><Link to="/about" onClick={() => setMenuOpen(false)}>
                   About Us
          </Link></li>

          <li><Link to="/contact" onClick={() => setMenuOpen(false)}>
                 Contact Us
          </Link></li>

           
           </ul>

        {/* MENU BUTTON */}
        <div className="menu-btn" onClick={() => setMenuOpen(!menuOpen)}>
          ☰
        </div>

      </nav>
    </>
  );
}

export default Navbar;